import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateCableLengthFilterNode from './CableLengthFilterNodeFactory'

const useCableLengthFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateCableLengthFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useCableLengthFilterNode
